import debounce from 'lodash.debounce';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Quill from 'quill';

require('./RichTextInput.css');

class CHRichTextInput extends Component {
    constructor(props){
	    super(props);
	}
	
	componentDidMount() {
        console.log('ehm');
		const { value, toolbar } = this.props;

        this.quill = new Quill(this.divRef, {
            modules: { toolbar },
            theme: 'snow',
        });

      //  this.quill.pasteHTML(value); //paste adds weird linebreaks and paragraphs
		//this.quill.setText(value+'\n');
		//this.quill.clipboard.dangerouslyPasteHTML(0,value);

        this.editor = this.divRef.querySelector('.ql-editor');
        this.quill.on('text-change', debounce(this.onTextChange, 500));
    }

    componentWillUnmount() {
        this.quill.off('text-change', this.onTextChange);
        this.quill = null;
    }

    onTextChange = () => {
       // this.props.input.onChange(this.editor.innerHTML);
    }

    updateDivRef = ref => {
        this.divRef = ref;
    }

    componentWillReceiveProps(nextProps) {
       // if (nextProps.input.value !== this.props.input.value) {
      //      this.quill.pasteHTML(nextProps.input.value);
      //  }
    }

    render() {
		const { id, value } = this.props;
        return <div className='aor-rich-text-input' id={id}>
            <div ref={this.updateDivRef} dangerouslySetInnerHTML={{__html: value}}>	
			</div>
        </div>
    }
}

CHRichTextInput.propTypes = {
    addField: PropTypes.bool.isRequired,
    addLabel: PropTypes.bool.isRequired,
    input: PropTypes.object,
    label: PropTypes.string,
    options: PropTypes.object,
    source: PropTypes.string,
    toolbar: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.bool,
    ]),
};

CHRichTextInput.defaultProps = {
    addField: true,
    addLabel: true,
    options: {},
    record: {},
    toolbar: true,
};

export default CHRichTextInput;


// WEBPACK FOOTER //
// ./src/utils/CHRichTextInput.js